export type ListingProfileViewMode = 'list' | 'create' | 'edit'

export type ListingProfileSaveReadinessInput = {
  viewMode: ListingProfileViewMode
  hydratingTitle: boolean
  hydratingPrice: boolean
  hydratingCategory: boolean
  hydratingImageMapping: boolean
  miscSectionBusy: boolean
  miscTemplateRetrying: boolean
  aiCategoryAutoMapLoading: boolean
  aiMiscAutoMapLoading: boolean
  templateDataLoading: boolean
  otherTemplateFieldLoader: boolean
  priceFieldsLoading: boolean
  priceMappingFieldsLoading: boolean
  priceTemplateFieldCount: number
  isAttributeLoading: boolean
  priceHydratePending: boolean
  /** Edit mode: misc template GET failed — save could persist empty misc mappings */
  editHasMiscLoadFailures: boolean
}

/** True while listing profile create/edit must not persist (data still loading or incomplete). */
export const isListingProfileSaveBlockedByLoading = (
  input: ListingProfileSaveReadinessInput
): boolean => {
  if (input.viewMode === 'list') return false

  if (
    input.hydratingTitle ||
    input.hydratingPrice ||
    input.hydratingCategory ||
    input.hydratingImageMapping
  ) {
    return true
  }

  if (input.miscSectionBusy || input.miscTemplateRetrying) return true
  if (input.aiCategoryAutoMapLoading || input.aiMiscAutoMapLoading) return true
  if (input.templateDataLoading || input.otherTemplateFieldLoader) return true
  if (input.isAttributeLoading) return true
  if (input.priceHydratePending) return true
  if (input.editHasMiscLoadFailures) return true

  if (
    input.priceTemplateFieldCount > 0 &&
    (input.priceFieldsLoading || input.priceMappingFieldsLoading)
  ) {
    return true
  }

  return false
}

export const LISTING_PROFILE_SAVE_LOADING_MESSAGE =
  'Profile data is still loading. Please wait before saving.'
